import React, { Component } from 'react';
import { Route, withRouter } from 'react-router-dom';
import styled from 'styled-components';
import withAnalytics, { initAnalytics } from 'react-with-analytics';

import API from '../../api/api';

import Loading from '../../components/Loading/Loading';

// initAnalytics(process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID);

// getComponent is a function that returns a promise for a component
// It will not be called until the first mount
const asyncComponent = getComponent => {
  return class AsyncComponent extends React.Component {
    static Component = null;
    state = { Component: AsyncComponent.Component };

    componentWillMount() {
      if (!this.state.Component) {
        getComponent().then(({ default: Component }) => {
          AsyncComponent.Component = Component;
          this.setState({ Component });
        });
      }
    }

    componentDidMount() {
      //Load OneTrust cookies scripts
      initAnalytics(process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID);
    }


    render() {
      const { Component } = this.state;
      if (Component) {
        return <Component {...this.props} />;
      }
      return <Loading/>;
    }
  };
};

const Site = asyncComponent(() => import("../Site/Site"));

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: ${props => props.backgroundColor ? props.backgroundColor : 'rgb(0, 135, 208)'};
`;


class App extends Component {
  constructor() {
    super();

    this.api = new API(process.env.REACT_APP_API, process.env.REACT_APP_MYACCOUNT_API);
  }

  render() {
    const state = this.props.appState;
    return (
      <Wrapper backgroundColor={state.ui.site.backgroundColor}>
        <Route path='/:schema?/:client?' render={({match}) => 
          <Site 
            match={match}
            api={this.api} 
            appState={state} 
            route={state.route} 
            update={this.props.setAppState} 
            validateCodeAndStoreSettings={this.props.validateCodeAndStoreSettings}
            validateCodeAndReturnRoute={this.props.validateCodeAndReturnRoute}
            setStaticPagesContent = {this.props.setStaticPagesContent}
            />
        } />
      </Wrapper>
    );
  }
}

export default withRouter(withAnalytics(App));;


// WEBPACK FOOTER //
// ./src/containers/App/App.js